var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#D3DCE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 14.75C10.25 13.9216 10.9216 13.25 11.75 13.25C12.5784 13.25 13.25 13.9216 13.25 14.75C13.25 15.5784 12.5784 16.25 11.75 16.25C10.9216 16.25 10.25 15.5784 10.25 14.75ZM14.75 14.75C14.75 14.3358 15.0858 14 15.5 14H29C29.4142 14 29.75 14.3358 29.75 14.75C29.75 15.1642 29.4142 15.5 29 15.5H15.5C15.0858 15.5 14.75 15.1642 14.75 14.75ZM10.25 20C10.25 19.1716 10.9216 18.5 11.75 18.5C12.5784 18.5 13.25 19.1716 13.25 20C13.25 20.8284 12.5784 21.5 11.75 21.5C10.9216 21.5 10.25 20.8284 10.25 20ZM14.75 20C14.75 19.5858 15.0858 19.25 15.5 19.25H29C29.4142 19.25 29.75 19.5858 29.75 20C29.75 20.4142 29.4142 20.75 29 20.75H15.5C15.0858 20.75 14.75 20.4142 14.75 20ZM10.25 25.25C10.25 24.4216 10.9216 23.75 11.75 23.75C12.5784 23.75 13.25 24.4216 13.25 25.25C13.25 26.0784 12.5784 26.75 11.75 26.75C10.9216 26.75 10.25 26.0784 10.25 25.25ZM14.75 25.25C14.75 24.8358 15.0858 24.5 15.5 24.5H29C29.4142 24.5 29.75 24.8358 29.75 25.25C29.75 25.6642 29.4142 26 29 26H15.5C15.0858 26 14.75 25.6642 14.75 25.25Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListLogo);
export default __webpack_public_path__ + "static/media/ListLogo.2353f2b19a50563d4ccc2f8d90bfa2e4.svg";
export { ForwardRef as ReactComponent };